/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingIdentitiesRequest {
    getFixupPrototypeFunction() { return BillingIdentitiesRequest.fixupPrototype; }

    static newInstance(model: Partial<BillingIdentitiesRequest>): BillingIdentitiesRequest {
        let obj = Object.assign(new BillingIdentitiesRequest(), model);
        BillingIdentitiesRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingIdentitiesRequest>): BillingIdentitiesRequest {
        if (!model) return null;
        return BillingIdentitiesRequest.newInstance(<BillingIdentitiesRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingIdentitiesRequest) {
        if (!obj) return;

        models.BillingIdentitiesRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingIdentitiesRequest): boolean {
        Object.setPrototypeOf(obj, BillingIdentitiesRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
        if (this.filters) {
            models.QueryOperator.fixupPrototype(this.filters);
        }
    }

    /**
     * Service Account IDs
     */
    service_account_ids: Array<string>;

    /**
     * Query expression to filter line items
     */
    filters: models.QueryOperator;

    /**
     * start of the spend period
     */
    start_date: Date;

    /**
     * end of the spend period
     */
    end_date: Date;

    /**
     * Platform source to scope the results to. If set, identities are read from the billing platform line items collection
     */
    platform: models.Platforms;

}
